export default {
    data() {
        return {
            productCategory: '',
            keyword: '',
            priceFrom: '',
            priceTo: '',
            dotFrom: '',
            dotTo: '',
            tireSizeW: '',
            tireSizeR: '',
            tireSizeD: '',
            engineOilType: '',
            carBrand: '',
            carModel: '',
            carYearSerie: ''
        };
    }
}